import React from "react";
import { Line } from "react-chartjs-2";

const WIPTrend = () => {

  const data = {
    labels: ["Sprint1","Sprint2","Sprint3","Sprint4"],
    datasets: [
      {
        label: "Active Tasks",
        data: [12,18,14,10],
        borderColor: "#06b6d4"
      }
    ]
  };

  return (
    <div className="bg-gray-800 p-5 rounded-xl">
      <h3 className="text-white mb-4">📊 Work In Progress Trend</h3>
      <Line data={data}/>
    </div>
  );
};

export default WIPTrend;